import { useRef, useEffect, useState } from "react";
import { FaTwitter } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaTelegramPlane } from "react-icons/fa";
import { FiShare2, FiLink } from "react-icons/fi";

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  const url =
  typeof window !== "undefined"
    ? window.location.href
    : "";

  // 바깥 클릭시 자동 닫힘
  useEffect(() => {
    if (!open) return;
    function handleClick(e: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  // URL 복사
  const handleCopy = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  // 트위터 공유
  const handleTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  // 페이스북 공유
  const handleFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      "_blank"
    );
  };

  // 텔레그램 공유
  const handleTelegram = () => {
    window.open(
      `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
      "_blank"
    );
  };

  return (
    <div className="flex items-center gap-2 justify-end my-2" ref={menuRef}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center px-3 py-1 bg-blue-900 text-white rounded"
        type="button"
      >
        <FiShare2 className="mr-1" />
        공유
      </button>
      {open && (
        <div className="flex items-center gap-2 ml-2">
          <button
            onClick={handleTwitter}
            className="rounded-full bg-black text-white p-2"
            title="트위터"
            type="button"
          >
            <FaTwitter size={18} />
          </button>
          <button
            onClick={handleFacebook}
            className="rounded-full bg-blue-700 text-white p-2"
            title="페이스북"
            type="button"
          >
            <FaFacebookF size={18} />
          </button>
          <button
            onClick={handleTelegram}
            className="rounded-full bg-blue-400 text-white p-2"
            title="텔레그램"
            type="button"
          >
            <FaTelegramPlane size={18} />
          </button>
          <button
            onClick={handleCopy}
            className="rounded-full bg-gray-700 text-white p-2"
            title="URL복사"
            type="button"
          >
            <FiLink size={18} />
          </button>
        </div>
      )}
      {copied && (
        <span className="ml-2 text-green-600 text-xs">링크가 복사되었습니다!</span>
      )}
    </div>
  );
}
